import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { PersonPhotoService } from "../../../services/nonanon/person/person-photo.service";
import { Subscription } from "rxjs/Subscription";
import { NotificationComponent } from "../../shared/notification.component";
import { PersonInfoService } from '../../../services/nonanon/person/person-info.service';

@Component({
  selector: 'app-access-code-person-photo',
  templateUrl: './access-code-person-photo.component.html'
})
export class PersonPhotoAccessCodeComponent implements OnInit, OnDestroy {
    @ViewChild('notification') notificationComponent: NotificationComponent;

    onPersonSelected: Subscription;
    onPersonPhotoChanged: Subscription;
    onPersonInfoChangedByAccessCode: Subscription;

    constructor(private personPhotoService: PersonPhotoService, private personInfoService: PersonInfoService) { }

    loading: boolean = false;

    private errorMessage: string = null;
    hasErrors() {
        return this.errorMessage != null;
    }
    getErrorMessage() {
        return this.hasErrors() ? this.errorMessage : "";
    }
    
    private personPhoto: any;

  ngOnInit() {
        if (this.personPhoto == null) {
            this.loading = true;

          console.log(this.personInfoService.getPersonInfoByAccessCode())

            this.personPhotoService.loadPersonPhoto(this.personInfoService.getPersonInfoByAccessCode().clientId);
        }

        this.onPersonPhotoChanged = this.personPhotoService.personPhotoChanged
            .subscribe(
              () => {
                if (this.personPhotoService.hasErrors()) {
                    this.errorMessage = this.personPhotoService.getErrorMessage();
                    this.notificationComponent.animateErrorAction(this.errorMessage);
                } else {
                    this.personPhoto = this.personPhotoService.getPersonPhoto();
                    this.notificationComponent.clear();
                }

                this.loading = false;
              });
    }

    ngOnDestroy() {
      this.onPersonPhotoChanged.unsubscribe();
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/nonanon/person/access-code-person-photo.component.ts